<template>
    <div></div>
  </template>
  
  <script>
  export default {
    data() {
      return {
        timeout: null,
      };
    },
    created() {
      this.resetTimer();
  
      // Eventos de actividad del usuario
      ["mousemove", "keydown", "click", "scroll", "touchstart"].forEach(evt =>
        window.addEventListener(evt, this.resetTimer)
      );
  
      // Observa cambios de ruta
      this.$watch(
        () => this.$route.path,
        (newPath) => {
          if (newPath === "/login") {
            clearTimeout(this.timeout);
          } else {
            this.resetTimer();
          }
        }
      );
    },
    methods: {
      resetTimer() {
        clearTimeout(this.timeout);
  
        if (this.$route.path !== "/login") {
          const INACTIVITY_LIMIT = 5 * 60 * 60 * 1000; // 5 horas
          this.timeout = setTimeout(this.logoutUser, INACTIVITY_LIMIT);
        }
      },
      logoutUser() {
        if (this.$route.path !== "/login") {
          // 🔑 Limpieza de tokens
          localStorage.removeItem("access");
          localStorage.removeItem("refresh");
  
          // 🚪 Redirección
          this.$router.push("/login");
          this.$toastr.info("Sesión expirada por inactividad");
        }
      },
    },
    beforeUnmount() {
      ["mousemove", "keydown", "click", "scroll", "touchstart"].forEach(evt =>
        window.removeEventListener(evt, this.resetTimer)
      );
      clearTimeout(this.timeout);
    },
  };
  </script>
  